var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SearchSelect',{attrs:{"label":"Mandant","items":_vm.vm.clientSelectionList,"loading":_vm.vm.loadResponse.loading,"disabled":_vm.disabled,"error":_vm.vm.loadResponse.error},on:{"change":function($event){return _vm.emitSelect($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }